import req from '../util/request'
import config from '../config'

export default {
  /**
   * 登出
   * @returns
   */
  logout () {
    return req({
      url: `${config.accountServer}/account/ticket/delete`
    })
  },

  getLoginInfo () {
    return req({
      url: `${config.accountServer}/serv/v1/user/auth`
    })
  }
}
